import React from "react";
import Banner from "../components/Agent Trust Components/Banner/Banner";
import Header from "../components/Agent Trust Components/Header/Header";
import ROI from "../components/Agent Trust Components/ROISection/ROI";
import UseCases from "../components/Agent Trust Components/UseCasesSection/UseCases";
import SecondBanner from "../components/Agent Trust Components/SecondBannerSection/SecondBanner";
import FAQ from "../components/Agent Trust Components/FAQSection/FAQ";
import Footer from "../components/Agent Trust Components/FooterSection/Footer";
import About from "../components/Agent Trust Components/AboutSection/About";
import Solution from "../components/Agent Trust Components/SolutionSection/Solution";
import SeeDemo from "../components/Agent Trust Components/SeeDemo/SeeDemo";
import Benefits from "../components/Agent Trust Components/BenefitsSection/Benefits";
import "../components/Agent Trust Components/agent-trust-main.css";
import Implementation from "../components/Agent Trust Components/HowItWorks/Implementation";
export default function AiTrustScoreAgent() {
  return (
    <div className="agent-trust-wrapper">
      <Header />
      {/*To use header component, you need to comment out the useEffect at line number 100 or provide section ids as mentioned in line number 13 */}
      <Banner />
      <About />
      <Solution />
      <Implementation />
      <ROI />
      <UseCases />
      <Benefits />
      <SeeDemo />
      <FAQ />
      <SecondBanner />
      <Footer />
    </div>
  );
}
